<script>
    /* Значки бокового меню: один набор линейных иконок 24×24, чтобы разделы
       читались с первого взгляда и выглядели как один комплект. */
    export let name = 'home';
</script>

<svg class="jrico" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
     stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
    {#if name === 'home'}
        <path d="M3 10.5 12 3l9 7.5"/><path d="M5.5 9.5V20h13V9.5"/><path d="M9.5 20v-5h5v5"/>
    {:else if name === 'users'}
        <circle cx="9" cy="8" r="3.2"/><path d="M3.5 19.5c0-3 2.5-5 5.5-5s5.5 2 5.5 5"/>
        <path d="M16 5.5a3 3 0 0 1 0 5.6"/><path d="M17 14.8c2.1.6 3.5 2.4 3.5 4.7"/>
    {:else if name === 'car'}
        <path d="M4 16.5v2.2h3v-2.2"/><path d="M17 16.5v2.2h3v-2.2"/>
        <path d="M3 16.5v-4l2-4.6C5.4 6.6 6.3 6 7.3 6h9.4c1 0 1.9.6 2.3 1.5l2 4.9v4z"/>
        <path d="M3.5 12.5h17"/><circle cx="7.5" cy="14.6" r="1"/><circle cx="16.5" cy="14.6" r="1"/>
    {:else if name === 'task'}
        <path d="M6.5 3.5h11a1.5 1.5 0 0 1 1.5 1.5v14a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19V5a1.5 1.5 0 0 1 1.5-1.5z"/>
        <path d="M8.5 9l1.6 1.6L13.5 7"/><path d="M8.5 15l1.6 1.6 3.4-3.6"/>
    {:else if name === 'shirt'}
        <path d="M9 3.5 5 5.5 3.5 9l2.5 1v10h12V10l2.5-1L19 5.5l-4-2"/>
        <path d="M9 3.5a3 3 0 0 0 6 0"/>
    {:else if name === 'log'}
        <path d="M5 4.5h14v15H5z"/><path d="M8 8.5h8M8 12h8M8 15.5h5"/>
    {:else if name === 'box'}
        <path d="M12 3.5 20 7v10l-8 3.5L4 17V7z"/><path d="M4 7l8 3.5L20 7"/><path d="M12 10.5v10"/>
    {:else if name === 'shield'}
        <path d="M12 3.5 19 6v6c0 4-3 7-7 8.5C8 19 5 16 5 12V6z"/><path d="M9.2 12.2l1.9 1.9 3.7-4"/>
    {:else if name === 'swords'}
        <path d="M14.5 3.5h5v5"/><path d="M19.5 3.5 11 12"/><path d="M4.5 3.5h5"/><path d="M3.5 8.5 12 17"/>
        <path d="M4 20.5l3-3M20 20.5l-3-3"/>
    {:else}
        <circle cx="12" cy="12" r="8"/>
    {/if}
</svg>

<style>
    .jrico { width: 2vh; height: 2vh; flex: 0 0 2vh; display: block; }
</style>
